import styled from 'styled-components';

export const RedirectLink = styled.a`
  display: block;
  text-decoration: underline;
  &:hover {
    text-decoration: underline;
  }
`;
